<template>
  <div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
    <div
      class="progress"
      style="height: 20px"
      v-if="progress > 0 && filesCount > 0"
    >
      <div
        class="progress-bar"
        role="progressbar"
        :style="`width: ${progress}%`"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {{ progress }}%
      </div>
    </div>
    <div v-else class="form-group mb-2">
      <label class="d-block font-weight-bold">
        {{ label || "Anexos" }}
        <b-link
          v-if="limit != false"
          href="#"
          @click.prevent="void 0"
          class="mb-2"
          variant="info"
          title=""
          v-b-popover.hover.html="
            ajuda ||
            '&#9702; Máximo 5 arquivos por vez <br/>&#9702; Tamanho máximo de <b>10MB</b> cada um.<br/>&#9702; Formatos suportados: PDF, DOC, XLS, CSV, JPG, PNG'
          "
        >
          <i class="fas fa-info-circle"></i>
        </b-link>
        <span v-if="required" class="text-danger">*</span>
      </label>
      <div class="input-group mb-0">
        <div class="custom-file">
          <input
            v-on:input="sendFile"
            type="file"
            class="custom-file-input"
            :readonly="readonly"
            ref="file"
            :multiple="multiple"
            :disabled="disabled"
            :accept="accept ? accept : '*'"
          />
          <label class="custom-file-label" v-html="text"></label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "value",
    "label",
    "required",
    "grid",
    "readonly",
    "multiple",
    "textInput",
    "progress",
    "limit",
    "disabled",
    "ajuda",
    "accept"
  ],
  data() {
    return {
      item: null,
      text:
        this.textInput || "Enviar no formato PDF, DOC, XLS, CSV, JPEG, PNG.",
      textDefault: "Enviar no formato PDF, DOC, XLS, CSV, JPEG, PNG.",
      filesCount: 0,
    };
  },
  watch: {
    progress(n, o) {
      if (this.files == null) {
        this.text = this.textDefault;
      }
    },
  },
  methods: {
    async sendFile() {
      this.text = this.$refs.file.files[0].name;
      var files = this.$refs.file.files[0];

      this.filesCount = this.$refs.file.files.length;
      if (this.filesCount > 1) {
        files = this.$refs.file.files;

        this.text +=
          this.item + "<b> e mais " + (this.filesCount - 1) + " arquivo(s)</b>";
      }

      this.$emit("submit", files);
      this.$refs.file.files = null;
      this.files = null;
    },
  },
};
</script>
<style lang="css">
.custom-file-label::after {
  content: "Escolha os arquivos" !important;
}
</style>
